import { render, staticRenderFns } from "./ModalCadastraAtividadeDisciplinaObjetivo.vue?vue&type=template&id=84ebd480"
import script from "./ModalCadastraAtividadeDisciplinaObjetivo.vue?vue&type=script&lang=js"
export * from "./ModalCadastraAtividadeDisciplinaObjetivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports